// Schedule import page: `/tournaments/new/import` makes an event from an
// organizer's file, `/tournaments/{id}/import` refreshes an event from a new
// version of it. Admins and referee assigners only; the callables decide
// which events they may write

import { Navigate, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import ScheduleImport from '../components/ScheduleImport';
import Spinner from '../components/Spinner';
import { useFirebase } from '../components/FirebaseContextProvider';
import { useTournament } from '../utils/hooks';

export default function PageScheduleImport() {
  const { tournamentId } = useParams();
  const { userManagesReferees } = useFirebase();
  const isNew = tournamentId === 'new';
  const { entity: tournament, isResolved } = useTournament(
    isNew ? null : tournamentId,
  );

  if (!userManagesReferees) return <Navigate to='/' replace />;

  if (!isNew && !tournament) {
    return (
      <Layout screenSized className='page-schedule-import'>
        {isResolved ? (
          <h1>{`Error: no route matches url "/tournaments/${tournamentId}/import"`}</h1>
        ) : (
          <Spinner show />
        )}
      </Layout>
    );
  }

  return (
    <Layout className='page-schedule-import' trail>
      {/* Keyed: a switch to another event must not carry this one's draft */}
      <ScheduleImport key={tournamentId} tournament={tournament} />
    </Layout>
  );
}
